<microsec-card [isBordered]="true">
  <div class="flex flex-col gap-4 w-full">
    <div class="font-bold text-xl">Manage User Access for this {{ scope | titlecase }}</div>
    <div class="text-gray-500">Through the Admin Console, you can</div>
    <div class="text-gray-500">
      <ul class="flex flex-col my-0 gap-2">
        <li>Add or remove members from this {{ scope }} group</li>
        <li>Map roles and permissions for members of this {{ scope }} group</li>
      </ul>
    </div>
    <p-divider styleClass="my-1" />
    <p-button severity="primary" [style]="{ 'text-transform': 'none' }" [rounded]="true" label="Manage in Admin Console" (onClick)="openLink()" />
  </div>
</microsec-card>
